<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_goods_pattern') || '花型'"
            prop="goodsPattern"
          >
            <el-input
              v-model="formData.goodsPattern"
              :disabled="formalDisabled"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_pattern') || '请填写花型'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_color') || '颜色'"
            prop="colorCode"
          >
            <el-select
              v-model="formData.colorCode"
              collapse-tags
              size="mini"
              style="width:100%"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_color') || '请选择颜色'
              "
              clearable
              filterable
              :disabled="formalDisabled"
              @change="colorChange"
            >
              <el-option
                v-for="item in colorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                class="brand-select"
              >
                <div style="float: left">
                  <span class="brand-select-item">{{ item.label }}</span>
                  <span
                    class="brand-select-item"
                    style="color: #8492a6; font-size: 13px"
                    >{{ item.brandName }}</span
                  >
                </div>
                <span
                  v-if="item.colorCard"
                  class="colorCard"
                  :style="{ background: item.colorCard }"
                />
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_colorCn') || '中文颜色'"
            prop="goodsColor"
          >
            <el-input
              v-model="formData.goodsColor"
              clearable
              maxlength="50"
              :disabled="formalDisabled"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_color_cn') || '请选择颜色'
              "
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_colorEn') || '英文颜色'"
            prop="goodsColorEn"
          >
            <el-input
              v-model="formData.goodsColorEn"
              clearable
              maxlength="50"
              :disabled="formalDisabled"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_color_en') || '请选择颜色'
              "
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_pack_size') || '售卖方式'"
            prop="skuPackSize"
          >
            <dict-select
              v-model="formData.skuPackSize"
              url="/master/common/dict/biz"
              :body="{ dictType: 'skuPackSize' }"
              :selectedLabel.sync="formData.skuPackSizeName"
              clearable
              filterable
              :disabled="formalDisabled"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_pack_size') ||
                  '请选择售卖方式'
              "
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_eanCode') || 'EAN条码'"
            prop="eanCode"
          >
            <el-input
              v-model="formData.eanCode"
              clearable
              maxlength="50"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_eanCode') || '请输入EAN条码'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_program_type') || '项目类型'"
            prop="programType"
          >
            <dict-select
              v-model="formData.programType"
              url="/sys/common/dict/system"
              :body="{ dictType: 'programType' }"
              clearable
              filterable
              :disabled="formalDisabled"
              size="mini"
              style="width:100%"
              @change="onProgramTypeChange"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_program_type') ||
                  '请选择项目类型'
              "
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_season') || '产品季节'"
            prop="productSeason"
          >
            <dict-select
              v-model="formData.productSeason"
              url="/master/common/dict/biz"
              :body="{ dictType: 'productSeason' }"
              clearable
              filterable
              :disabled="formalDisabled || readProductSeasonFlag"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_season') || '请选择产品季节'
              "
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_goods_size') || '产品尺寸'"
            prop="goodsSize"
          >
            <el-input
              v-model="formData.goodsSize"
              :disabled="formalDisabled"
              readonly
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_design') || '企划人员'"
            prop="designCode"
          >
            <dict-select
              v-model="formData.designCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.designName"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col> -->
      </el-row>

      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_goods_area') || '产品面积(㎡)'"
          >
            <el-input-number
              v-model="formData.goodsArea"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_goodsArea') ||
                  '请输入产品面积'
              "
              controls-position="right"
              :step="1"
              :min="0"
              :precision="8"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_ncNo') || 'NC产品编号'"
            prop="ncNo"
          >
            <el-input
              v-model="formData.ncNo"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_ncNo') || '请选择工厂'
              "
              clearable
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_factory') || '成品工厂(默认)'"
            prop="scmCode"
          >
            <el-input
              v-model="formData.scmName"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_factory') || '请选择工厂'
              "
              clearable
              readonly
            />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item :label="ftyPriceLable" prop="ftyPrice">
            <el-input
              v-model="formData.ftyPrice"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_ftyPrice') || '请选择工厂'
              "
              clearable
              readonly
            />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_buyer') || '采购人员'"
            prop="buyerCode"
          >
            <el-input
              v-model="formData.buyerName"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_buyer') || '请选择工厂'
              "
              clearable
              readonly
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_materialInfo') || '材料信息'"
            prop="materialInfo"
          >
            <el-input
              v-model="formData.materialInfo"
              clearable
              type="textarea"
              :rows="4"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_materialInfo') ||
                  '请输入材料信息'
              "
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_goodsProperties') || '产品属性'"
            prop="goodsProperties"
          >
            <dict-select
              v-model="formData.goodsProperties"
              url="/master/common/dict/biz"
              :body="{ dictType: 'goodsProperties' }"
              :selectedLabel.sync="formData.goodsProperties"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_goodsProperties') ||
                  '请选择产品属性'
              "
              clearable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_evg_sku_unitLength') || '单品包装长(cm)'"
                prop="unitLength"
              >
                <el-input-number
                  v-model="formData.unitLength"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_evg_sku_unitWidth') || '单品包装宽(cm)'"
                prop="unitWidth"
              >
                <el-input-number
                  v-model="formData.unitWidth"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_evg_sku_unitHeight') || '单品包装高(cm)'"
                prop="unitHeight"
              >
                <el-input-number
                  v-model="formData.unitHeight"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_goodsWeight') || '单品重量(kg)'"
            prop="goodsWeight"
          >
            <el-input-number
              v-model="formData.goodsWeight"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_unitWeight') || '单品包装重量(kg)'"
            prop="unitWeight"
          >
            <el-input-number
              v-model="formData.unitWeight"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              @change="changeCtnGrossWeight"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_unitCbm') || '单品包装体积(m³)'"
            prop="unitCbm"
          >
            <el-input v-model="unitCbm" controls-position="right" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_specInUnitQty') || '单品规格入数'"
            prop="specInUnitQty"
          >
            <el-input v-model="formData.specInUnitQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_evg_sku_unitLength_read') || '单品包装长(英寸)'
                "
              >
                <el-input
                  v-model="unitLengthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_evg_sku_unitWidth_read') || '单品包装宽(英寸)'
                "
              >
                <el-input
                  v-model="unitWidthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_evg_sku_unitHeight_read') || '单品包装高(英寸)'
                "
              >
                <el-input
                  v-model="unitHeightRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_goodsWeight_read') || '单品重量(磅)'"
          >
            <el-input
              v-model="goodsWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_evg_sku_unitWeight_read') || '单品包装重量(磅)'
            "
          >
            <el-input
              v-model="unitWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_evg_sku_unitCbm_read') || '单品包装体积(英尺³)'
            "
          >
            <el-input
              v-model="unitCbmRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_carton_type') || '纸箱类型'"
            prop="cartonType"
          >
            <dict-select
              v-model="formData.cartonType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'cartonType' }"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_cartonType') ||
                  '请选择纸箱类型'
              "
              clearable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_evg_sku_ctnLength') || '纸箱长(cm)'"
                prop="ctnLength"
              >
                <el-input-number
                  v-model="formData.ctnLength"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_evg_sku_ctnWidth') || '纸箱宽(cm)'"
                prop="ctnWidth"
              >
                <el-input-number
                  v-model="formData.ctnWidth"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_evg_sku_ctnHeight') || '纸箱高(cm)'"
                prop="ctnHeight"
              >
                <el-input-number
                  v-model="formData.ctnHeight"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_ctnNetWeight') || '箱净重(kg)'"
          >
            <el-input
              v-model="ctnNetWeightKgRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_ctnGrossWeight') || '箱毛重(kg)'"
          >
            <el-input-number
              v-model="ctnGrossWeightKgRead"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_ctnCbm') || '纸箱体积(m³)'"
          >
            <el-input v-model="ctnCbm" controls-position="right" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_inCtnQty') || '装箱入数'"
            prop="inCtnQty"
          >
            <el-input-number
              v-model="formData.inCtnQty"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="0"
              style="width:100%"
              @change="changeCtnGrossWeight"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_evg_sku_ctnLength_read') || '纸箱长(英寸)'
                "
              >
                <el-input
                  v-model="ctnLengthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_evg_sku_ctnWidth_read') || '纸箱宽(英寸)'
                "
              >
                <el-input
                  v-model="ctnWidthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_evg_sku_ctnHeight_read') || '纸箱高(英寸)'
                "
              >
                <el-input
                  v-model="ctnHeightRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_boxNetWeight_read') || '箱净重(磅)'"
          >
            <el-input
              v-model="ctnNetWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_evg_sku_ctnGrossWeight_read') || '箱毛重(磅)'
            "
          >
            <el-input
              v-model="ctnGrossWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_ctnCbm_read') || '纸箱体积(英尺³)'"
          >
            <el-input v-model="ctnCbmRead" controls-position="right" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_hscodeCn') || '中国HSCODE'"
          >
            <el-input
              v-model="formData.hscodeCn"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_hscodeCn') ||
                  '请输入中国HSCODE'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_hscodeNameCn') || '报关中文品名'"
          >
            <el-input
              v-model="formData.hscodeName"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_hscodeNameCn') ||
                  '请输入报关中文品名'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_hscodeNameEn') || '报关英文品名'"
          >
            <el-input
              v-model="formData.hscodeNameEn"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_hscodeNameEn') ||
                  '请输入报关英文品名'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_needInspection') || '是否商检'"
          >
            <el-select
              v-model="formData.needInspection"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_needInspection') ||
                  '请选择是否商检'
              "
              size="mini"
              style="width:100%"
            >
              <el-option
                v-for="item in needInspectionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_customsPrice') || '报关单价'"
          >
            <el-input-number
              v-model="formData.customsPrice"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_customsPrice') ||
                  '请输入报关单价'
              "
              controls-position="right"
              :step="1"
              :min="0"
              :precision="4"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_taxRefundCn') || '中国退税'"
          >
            <el-input-number
              v-model="formData.taxRefundCn"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_taxRefundCn') ||
                  '请输入中国退税'
              "
              controls-position="right"
              :step="1"
              :min="0"
              :precision="4"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_ctnSkuNo') || '纸箱SKU(外箱印刷)'"
          >
            <el-input
              v-model="formData.ctnSkuNo"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_ctnSkuNo') ||
                  '请输入纸箱SKU(外箱印刷)'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_originalPlace') || '境内货源地'"
          >
            <el-input
              v-model="formData.originalPlace"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_originalPlace') ||
                  '请输入境内货源地'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_evg_sku_declarationElements') || '申报要素'"
          >
            <el-input
              v-model="formData.declarationElements"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_declarationElements') ||
                  '请输入申报要素'
              "
              clearable
              type="textarea"
              :rows="3"
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import {
  multiply,
  multiplyRound,
  divideRound,
  add,
} from '@/libs/util.number.js'
import { request } from '@/api/service'

export default {
  mixins: [EditLoading],
  props: {
    evgSkuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    evgSkuStatus: { type: String, default: '' },
    evgSpuCode: { type: String, default: '' },
    form: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        colorCode: '',
        goodsColorEn: '',
        goodsColor: '',
        goodsName: '',
        goodsNameEn: '',
        designCode: '',
        designName: '',
        isVc: '',
      },
      formalDisabled: false,
      masterCategoryParams: { parentCode: 'ABSHome' },
      categoryTree: [],
      colorOptions: [],
      readProductSeasonFlag: false,
      needInspectionOptions: [
        {
          value: 'Y',
          label: '是',
        },
        {
          value: 'N',
          label: '否',
        },
      ],
      ctnGrossWeightKgRead: 0,
    }
  },
  computed: {
    detailCategoryParams() {
      return { parentCode: this.formData.masterCategoryCode || 'x' }
    },
    unitCbm() {
      const { unitLength, unitWidth, unitHeight } = this.formData
      return divideRound(
        multiply(multiply(unitLength, unitWidth), unitHeight),
        1000000,
        8
      )
    },
    ctnCbm() {
      const { ctnLength, ctnWidth, ctnHeight } = this.formData
      return divideRound(
        multiply(multiply(ctnLength, ctnWidth), ctnHeight),
        1000000,
        8
      )
    },
    unitLengthRead() {
      return divideRound(this.formData.unitLength, 2.54, 7)
    },
    unitWidthRead() {
      return divideRound(this.formData.unitWidth, 2.54, 7)
    },
    unitHeightRead() {
      return divideRound(this.formData.unitHeight, 2.54, 7)
    },
    goodsWeightRead() {
      return multiplyRound(this.formData.goodsWeight, 2.20462262185, 7)
    },
    unitWeightRead() {
      return multiplyRound(this.formData.unitWeight, 2.20462262185, 7)
    },
    unitCbmRead() {
      return multiplyRound(this.unitCbm, 35.3147248, 7)
    },
    ctnLengthRead() {
      return divideRound(this.formData.ctnLength, 2.54, 7)
    },
    ctnWidthRead() {
      return divideRound(this.formData.ctnWidth, 2.54, 7)
    },
    ctnHeightRead() {
      return divideRound(this.formData.ctnHeight, 2.54, 7)
    },
    ctnNetWeightRead() {
      return multiplyRound(this.ctnNetWeightKgRead, 2.20462262185, 7)
    },
    ctnGrossWeightRead() {
      return multiplyRound(this.ctnGrossWeightKgRead, 2.20462262185, 7)
    },
    ctnNetWeightKgRead() {
      return multiplyRound(this.formData.unitWeight, this.formData.inCtnQty, 3)
    },
    ctnCbmRead() {
      return multiplyRound(this.ctnCbm, 35.3147248, 7)
    },
    required() {
      return !this.evgSpuCode
    },
    requiredAdd() {
      return false
    },
    ftyPriceLable() {
      const { ftyPriceCurrencyUnit = '' } = this.formData || {}
      return (
        (this.$l('INDEX.form_evg_sku_ftyPrice') || '工厂单价') +
        (ftyPriceCurrencyUnit ? `(${ftyPriceCurrencyUnit})` : '')
      )
    },
    rules() {
      return {
        goodsName: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_evg_sku_goodsNameCn') || '请输入中文名称',
            trigger: 'blur',
          },
        ],
        goodsNameEn: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_evg_sku_goodsNameEn') || '请输入英文名称',
            trigger: 'blur',
          },
        ],
        brandCode: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_brand') || '请选择品牌',
            trigger: 'blur',
          },
        ],
        skuPackSize: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_evg_sku_sellTypes') || '请选择售卖方式',
            trigger: 'blur',
          },
        ],
        detailCategoryCode: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_evg_sku_masterCategory') || '请选择品类',
            trigger: ' change',
          },
        ],
        programType: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_evg_sku_programType') || '请选择项目类型',
            trigger: ' change',
          },
        ],
        productSeason: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_evg_sku_productSeason') || '请选择产品季节',
            trigger: ' change',
          },
        ],
        goodsColor: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_evg_sku_goodsColorCn') || '请输入中文颜色',
            trigger: 'blur',
          },
        ],
        goodsColorEn: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_evg_sku_goodsColorEn') || '请输入英文颜色',
            trigger: 'blur',
          },
        ],
        goodsSize: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_goodsSize') || '请输入产品尺寸',
            trigger: 'blur',
          },
        ],
        goodsPattern: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_Pattern') || '请输入花型',
            trigger: 'blur',
          },
        ],
        colorCode: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_color_data') || '请选择颜色',
            trigger: 'change',
          },
        ],
        // isVc: [
        //   {
        //     required: true,
        //     message: this.$l('INDEX.tips_select_data') || '请选择...',
        //     trigger: 'change',
        //   },
        // ],
        eanCode: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_eanCode') || '请输入EAN条码',
            trigger: 'change',
          },
        ],
        // designCode: [
        //   {
        //     required: true,
        //     message:
        //       this.$l('INDEX.form_placeholder_design') || '请选择企划人员',
        //     trigger: 'blur',
        //   },
        // ],
        materialInfo: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_materialInfo') || '请输入材料信息',
            trigger: 'blur',
          },
        ],
        goodsProperties: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_goodsProperties') ||
              '请输入产品属性',
            trigger: 'blur',
          },
        ],
        unitLength: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_unitLength') || '请输入单品包装长',
            trigger: 'blur',
          },
        ],
        unitWidth: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_unitWidth') || '请输入单品包装宽',
            trigger: 'blur',
          },
        ],
        unitHeight: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_unitHeight') || '请输入单品包装高',
            trigger: 'blur',
          },
        ],
        goodsWeight: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_goodsWeight') || '请输入单品重量',
            trigger: 'blur',
          },
        ],
        unitWeight: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_unitWeight') || '请输入单品包装重量',
            trigger: 'blur',
          },
        ],
        inCtnQty: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_inCtnQty') || '请输入装箱入数',
            trigger: 'blur',
          },
        ],
        ctnLength: [
          {
            required: this.requiredAdd,
            message: this.$l('INDEX.rules_evg_sku_ctnLength') || '请输入纸箱长',
            trigger: 'blur',
          },
        ],
        ctnWidth: [
          {
            required: this.requiredAdd,
            message: this.$l('INDEX.rules_evg_sku_ctnWidth') || '请输入纸箱宽',
            trigger: 'blur',
          },
        ],
        ctnHeight: [
          {
            required: this.requiredAdd,
            message: this.$l('INDEX.rules_evg_sku_ctnHeight') || '请输入纸箱高',
            trigger: 'blur',
          },
        ],
        ctnNetWeight: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_ctnNetWeight') || '请输入箱净重',
            trigger: 'blur',
          },
        ],
        ctnGrossWeight: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_ctnGrossWeight') || '请输入箱毛重',
            trigger: 'blur',
          },
        ],
        cartonType: [
          {
            required: this.requiredAdd,
            message:
              this.$l('INDEX.rules_evg_sku_carton_type') || '请选择纸箱类型',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
    this.getSpuData()
    this.getTreeData()
    this.getColor()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getData() {
      if (!this.evgSkuCode) return
      let res = await this.$api
        .ecomEvgSkuDetailApi({ evgSkuCode: this.evgSkuCode })
        .catch(() => null)
      if (!res) return
      const data = res.body || {}
      this.formData = data
      this.ctnGrossWeightKgRead = this.formData.ctnGrossWeight
      // this.formalDisabled = this.formData.evgSkuStatus == 'Y'
      this.formalDisabled =
        this.formData.evgSkuStatus == 'Y' ||
        (this.formData.evgSkuStatus == 'C' &&
          this.formData.applicationStatus == 'O')
      if (this.formData.programType && this.formData.programType == 'Core') {
        this.formData.productSeason = 'CORE'
        this.readProductSeasonFlag = true
      } else {
        this.readProductSeasonFlag = false
      }

      this.$emit('update:evgSkuStatus', data.evgSkuStatus || '')
    },
    getSpuData() {
      if (this.evgSkuCode) return
      if (!this.evgSpuCode) return
      this.$api
        .ecomEvgSpuDetailApi({ evgSpuCode: this.evgSpuCode })
        .then((res) => {
          const data = res.body
          this.formData.spuGoodsName = data.goodsName
          this.formData.spuGoodsNameEn = data.goodsNameEn
          this.formData.goodsName = data.goodsName
          this.formData.goodsNameEn = data.goodsNameEn
          this.formData.brandCode = data.brandCode
          this.formData.brandName = data.brandName
          this.formData.collectionNo = data.collectionNo
          this.formData.collectionName = data.collectionName
          this.formData.masterCategoryName = data.masterCategoryName
          this.formData.masterCategoryCode = data.masterCategoryCode
          this.formData.detailCategoryCode = data.categoryCode
          this.formData.detailCategoryName = data.categoryName
          this.formData.categoryFullName = data.categoryFullName
          this.formData.designCode = data.designCode
          this.formData.designName = data.designName
          this.formData.isVc = data.isVc
          this.formData.v_isVc = data.isVc == 'Y' ? 'VC' : '否'
        })
    },
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi(this.masterCategoryParams)
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    onCategoryChange() {
      const nodes = this.$refs.cascaderCategoryTreeRef.getCheckedNodes()
      if (nodes?.length && nodes[0] && nodes[0].path?.length) {
        this.formData.displayCategoryCode = nodes[0].path.join(',')
        this.formData.masterCategoryCode = nodes[0].path[0]
      } else {
        this.formData.displayCategoryCode = null
        this.formData.masterCategoryCode = null
      }
    },
    onProgramTypeChange() {
      this.formData.productSeason = ''
      if (this.formData.programType && this.formData.programType == 'Core') {
        this.formData.productSeason = 'CORE'
        this.readProductSeasonFlag = true
      } else {
        this.readProductSeasonFlag = false
      }
    },
    getColor() {
      request({
        url: '/ecom/amz/sku/dict/color',
        method: 'post',
      }).then((res) => {
        this.colorOptions = res.body.data
      })
    },
    async reloadSku() {
      if (!this.evgSkuCode) return
      let res = await this.$api
        .ecomEvgSkuDetailApi({ evgSkuCode: this.evgSkuCode })
        .catch(() => null)
      if (!res) return
      const data = res.body || {}
      const { scmCode, scmName, ncNo, ftyPrice, buyerCode, buyerName } = data
      this.formData.scmCode = scmCode
      this.formData.scmName = scmName
      this.formData.buyerCode = buyerCode
      this.formData.buyerName = buyerName
      this.formData.ncNo = ncNo
      this.formData.ftyPrice = ftyPrice
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()
      const res = await this.saveApi()
      this.loadingClose()
      if (!res) return
      const { status, body } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if (!this.evgSkuCode && !this.evgSpuCode) {
        // await this.closeCurPage()
        this.$router.replace({
          name: 'ecom-base-awsGoods-detail',
          params: { code: body, pageType: 'edit' },
          query: { evgSkuNo: this.formData.evgSkuNo },
        })
        return
      }
      this.$emit('update:evgSkuCode', body || '')
      setTimeout(() => {
        this.getData()
        this.$emit('reload')
      }, 0)
    },
    saveApi() {
      const params = {
        ...this.formData,
        unitCbm: this.unitCbm,
        ctnCbm: this.ctnCbm,
        ctnNetWeight: this.ctnNetWeightKgRead,
        ctnGrossWeight: this.ctnGrossWeightKgRead,
        evgSpuCode: this.evgSpuCode || this.formData.evgSpuCode,
      }
      let goodsName = params.spuGoodsName
      let goodsNameEn = params.spuGoodsNameEn
      if (!this.formalDisabled && !!goodsName && !!goodsNameEn) {
        if ('single' == params.skuPackSize) {
          goodsName = goodsName + params.goodsColor + (params.goodsSize || '')
          goodsNameEn =
            goodsNameEn +
            ' ' +
            params.goodsColorEn +
            ' ' +
            (params.goodsSize || '')
        } else {
          goodsName = goodsName + params.skuPackSizeName + params.goodsColor
          goodsNameEn =
            goodsNameEn + ' ' + params.skuPackSize + ' ' + params.goodsColorEn
        }
        params.goodsName = goodsName
        params.goodsNameEn = goodsNameEn
      }

      if (this.evgSpuCode && !this.evgSkuCode) {
        return this.$api.ecomEvgSpuAddSkuApi(params).catch(() => null)
      } else {
        return this.$api.ecomEvgSkuSaveApi(params).catch(() => null)
      }
    },
    async colorChange(code) {
      if (!code) return
      const res = await request({
        url: '/ecom/amz/sku/dict/color/detail',
        method: 'POST',
        data: { colorCode: code },
      }).catch(() => null)
      if (!res) return
      const { colorName, colorNameEn } = res.body
      this.formData.goodsColor = colorName
      this.formData.goodsColorEn = colorNameEn
    },
    changeCtnGrossWeight() {
      this.ctnGrossWeightKgRead = add(this.ctnNetWeightKgRead, 1)
    },

    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.colorCard {
  float: right;
  margin: 3px 0px 0px 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 60px;
  color: #ffffff;
}

.side-frame-success {
  padding: 2px 10px;
  border-left: 3px solid $color-success;
  margin: 0;
}
.border-detail-main-form {
  margin-top: -1px;
}

.brand-select {
  height: auto !important;
  line-height: 20px !important;
  margin: 6px 0;
  .brand-select-item {
    display: block;
  }
}
</style>
